export default __webpack_public_path__ + "static/assets/9ab9feb3f9d4449ac2dea6a6c8b3e2ad.png";